import React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './AboutPage.css';

function AboutPage() {
  return (
    <>
      <Header />
      
      <div className="about-page">
        <div className="container">

          {/* Hero Section */}
          <section className="about-hero" style={{ 
            backgroundImage: 'url(https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1350&q=80)' 
          }}>
            <div className="hero-overlay">
              <h1>About Heaven Green Infra. Landscape</h1>
              <p className="tagline">One Step for Green World</p>
            </div>
          </section>

          {/* Who We Are */}
          <section className="about-section who-we-are">
            <div className="section-grid">
              <div className="section-content">
                <h2>Who We Are</h2>
                <p>
                  We are a professional landscaping company specializing in landscape design, 
                  lawn care, garden maintenance, irrigation systems, hardscaping, and outdoor 
                  living solutions. Our experienced team is committed to providing reliable, 
                  affordable, and high-quality services tailored to every client's needs.
                </p>
                <p>
                  Founded with a passion for creating beautiful outdoor spaces, our landscaping 
                  company has been dedicated to transforming residential and commercial properties 
                  into stunning landscapes. We combine creativity, quality craftsmanship, and 
                  attention to detail to deliver results that exceed our clients' expectations.
                </p>
              </div>
              <div className="section-image">
                <img 
                  src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=400&q=80" 
                  alt="Company Office" 
                />
              </div>
            </div>
          </section>

          {/* Experience & Team */}
          <section className="about-section">
            <div className="section-grid">
              <div className="section-content">
                <h2>Our Experience</h2>
                <p>
                  With years of experience in the landscaping industry, we have successfully 
                  completed projects ranging from residential gardens to large commercial 
                  landscapes. Our expertise allows us to handle projects of every size with 
                  precision and care.
                </p>
              </div>
              <div className="section-content">
                <h2>Our Team</h2>
                <p>
                  Our team consists of experienced landscape designers, horticulture specialists, 
                  irrigation experts, and skilled installation professionals. Together, we work to 
                  bring every client's vision to life while maintaining the highest standards of 
                  quality and professionalism.
                </p>
              </div>
            </div>
          </section>

          {/* Mission & Vision */}
          <section className="about-section mission-vision">
            <div className="mission">
              <div className="icon">🎯</div>
              <h3>Our Mission</h3>
              <p>
                Our mission is to create beautiful, sustainable, and functional outdoor spaces 
                while delivering exceptional customer service, innovative designs, and 
                long-lasting landscaping solutions.
              </p>
            </div>
            <div className="vision">
              <div className="icon">👁️</div>
              <h3>Our Vision</h3>
              <p>
                To become a trusted leader in the landscaping industry by enhancing outdoor 
                environments through creativity, professionalism, and environmentally 
                responsible practices.
              </p>
            </div>
          </section>

          {/* Why Choose Us */}
          <section className="about-section">
            <h2>Why Choose Us</h2>
            <div className="why-choose-grid">
              <div className="why-choose-item">
                <span className="check-icon">✓</span>
                <p>Experienced and skilled professionals</p>
              </div>
              <div className="why-choose-item">
                <span className="check-icon">✓</span>
                <p>High-quality workmanship</p>
              </div>
              <div className="why-choose-item">
                <span className="check-icon">✓</span>
                <p>Customized landscaping solutions</p>
              </div>
              <div className="why-choose-item">
                <span className="check-icon">✓</span>
                <p>Affordable and transparent pricing</p>
              </div>
              <div className="why-choose-item">
                <span className="check-icon">✓</span>
                <p>Timely project completion</p>
              </div>
              <div className="why-choose-item">
                <span className="check-icon">✓</span>
                <p>Eco-friendly landscaping practices</p>
              </div>
              <div className="why-choose-item">
                <span className="check-icon">✓</span>
                <p>Excellent customer support</p>
              </div>
              <div className="why-choose-item">
                <span className="check-icon">✓</span>
                <p>100% customer satisfaction</p>
              </div>
            </div>
          </section>

          {/* Gallery */}
          <section className="about-section gallery-section">
            <h2>Our Work</h2>
            <div className="gallery-grid">
              <img 
                src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=300&q=80" 
                alt="Construction Site" 
              />
              <img 
                src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=300&q=80" 
                alt="Building Construction" 
              />
              <img 
                src="https://images.unsplash.com/photo-1571330735066-03aaa9429d89?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=300&q=80" 
                alt="Infrastructure Project" 
              />
              <img 
                src="https://images.unsplash.com/photo-1581093588401-fbb62a02f120?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=300&q=80" 
                alt="Construction Equipment" 
              />
            </div>
          </section>

          {/* Contact with Google Maps */}
          <section className="about-section contact-info">
            <h2>Visit Us</h2>
            <div className="contact-grid">
              <div>
                <p>
                  <strong>Address:</strong><br />
                  Near Maa Sharda Public School,<br />
                  Main Road Kathadih, Mathpurena,<br />
                  Raipur
                </p>
                <p>
                  <strong>Phone:</strong> <a href="tel:+919981206128">+91 99812 06128</a>, <a href="tel:+916264573743">+91 62645 73743</a>
                </p>
                <p>
                  <strong>Email:</strong><br />
                  <a href="mailto:heavengreeninfra0@gmail.com">heavengreeninfra0@gmail.com</a><br />
                  <a href="mailto:heavengreenprojects@gmail.com">heavengreenprojects@gmail.com</a><br />
                  <a href="mailto:sahurajeshkumar84@gmail.com">sahurajeshkumar84@gmail.com</a>
                </p>
                <p>
                  <strong>Business Hours:</strong><br />
                  Mon - Sat: 10:00 AM - 5:00 PM<br />
                  Sun: Closed
                </p>
                <p>
                  <strong>Google Maps:</strong><br />
                  <a 
                    href="https://www.google.com/maps/search/?api=1&query=Near+Maa+Sharda+Public+School+Main+Road+Kathadih+Mathpurena+Raipur" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="map-link"
                  >
                    Open in Google Maps
                  </a>
                </p>
              </div>
              <div className="map-container">
                <iframe
                  src="https://www.google.com/maps?q=Near+Maa+Sharda+Public+School+Main+Road+Kathadih+Mathpurena+Raipur&output=embed"
                  width="100%"
                  height="300"
                  style={{ border: 0, borderRadius: '10px' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Heaven Green Location"
                />
              </div>
            </div>
          </section>

        </div>
      </div>

      <Footer />
    </>
  );
}

export default AboutPage;